'use strict';

window.nodejs = false;
window.path = window.path || '/';

var jquery = require('@common/Scripts/libs/jquery-1.12.4.min.js');
// Legacy browser plugins (History.js, Bootstrap, SignalR, etc.) read jQuery
// from window while their module body is being evaluated. Publish it before
// requiring any application module that can pull those plugins into the graph.
window.$ = window.jQuery = jquery;

var pageLoadersModule = require('@app/runtime/pages-loaders.js');
var pageLoaders = pageLoadersModule.default || pageLoadersModule;
var factoryModule = require('@common/Scripts/core/factory/factory.js');
var $ = factoryModule.default || factoryModule;
var urlModule = require('@common/Scripts/core/url/url.js');
var url = urlModule.default || urlModule;

var initialData = window.dataFromServer ? window.dataFromServer.init.data : {};
var sectionName = initialData.section && initialData.section.name === 'back' ? 'back' : 'main';
var mainModule = sectionName === 'back' ? 'backmain' : 'main';
var deferredPages = (initialData.pages || [])
	.map(function (page) {
		return page.typePath || page.name;
	})
	.filter(Boolean);

deferredPages = deferredPages.filter(function (moduleName, index, modules) {
	return modules.indexOf(moduleName) === index;
});
var additionalPages = window.requirePages || [];
deferredPages = deferredPages.concat(additionalPages).filter(function (moduleName, index, modules) {
	return modules.indexOf(moduleName) === index;
});

var loadSection = sectionName === 'back'
	? function () { return Promise.all([import(/* webpackChunkName: "legacy-section-back" */ '@app/back/main.js'), import(/* webpackChunkName: "legacy-section-back" */ '@app/back/main.less')]); }
	: function () { return Promise.all([import(/* webpackChunkName: "legacy-section-main" */ '@app/main.js'), import(/* webpackChunkName: "legacy-section-main" */ '@app/main.less')]); };

// Keep the legacy bootstrap order: first register the site and base page
// types, then create the SSR object graph, and only afterwards register the
// concrete page modules. Loading all of them in parallel races factory.add.
loadSection().then(function () {
	// RequireJS exposed `require` on window, which factory.js used as the
	// signal to replace its plain setter with the observable JsViews setter.
	// Webpack keeps require module-local, so initialize that integration here.
	$.initJsViewsSetProperty();

	$.site = $.getObject(initialData, mainModule);

	var finishBootstrap = function () {
		// With SSR the page can finish its create/activate cycle before the
		// advanced-render observer is attached. Link a fresh client view when
		// that transition has already been missed.
		if ($.site.tmplLinkDfd && $.site.tmplLinkDfd.state() === 'pending') {
			if (!$.site.active && $.site.pages && $.site.pages.length) {
				$.setProperty($.site, 'active', $.site.pages[0]);
			}

			$.site.render();
		}
	};

	pageLoaders.loadAll(deferredPages).then(finishBootstrap);
});
